import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./discount_level.js";
//#region src/discount_level_helper.ts
var discount_level_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(discountLevel) {
	switch (discountLevel) {
		case 0: return "Check";
		case 1: return "Item";
	}
}
//#endregion
export { discount_level_helper_exports, name };

//# sourceMappingURL=discount_level_helper.js.map